/**
 * Key names for the `toast` section of the locale files.
 *
 * Call sites read `t(`${TOAST}.${T.CHAT_PINNED}`)` instead of spelling the path out, so a
 * renamed key breaks at import rather than silently rendering the raw path — `i18n.t`
 * falls back to the path string when a lookup misses.
 *
 * Every key here must exist in en.json, ru.json AND ar.json.
 */
export const TOAST = 'toast';

export const T = {
    // Chat actions — recent chat context menu
    CHAT_ARCHIVED: 'CHAT_ARCHIVED',
    CHAT_UNARCHIVED: 'CHAT_UNARCHIVED',
    CHAT_PINNED: 'CHAT_PINNED',
    CHAT_UNPINNED: 'CHAT_UNPINNED',
    PIN_LIMIT_REACHED: 'PIN_LIMIT_REACHED',
    ADDED_TO_FAVOURITES: 'ADDED_TO_FAVOURITES',
    REMOVED_FROM_FAVOURITES: 'REMOVED_FROM_FAVOURITES',
    MARKED_AS_UNREAD: 'MARKED_AS_UNREAD',
    MARKED_AS_READ: 'MARKED_AS_READ',
    CHAT_MUTED: 'CHAT_MUTED',
    CHAT_UNMUTED: 'CHAT_UNMUTED',
    CHAT_CLEARED: 'CHAT_CLEARED',
    CHAT_DELETED: 'CHAT_DELETED',
    GROUP_CHAT_DELETED: 'GROUP_CHAT_DELETED',
    EXIT_GROUP_SUCCESS: 'EXIT_GROUP_SUCCESS',
    USER_BLOCK_SUCCESS: 'USER_BLOCK_SUCCESS',
    USER_UNBLOCK_SUCCESS: 'USER_UNBLOCK_SUCCESS',
    GROUP_UPDATED: 'GROUP_UPDATED',
    REPORT_SENT_SUCCESS: 'REPORT_SENT_SUCCESS',
    NO_MESSAGES_TO_REPORT: 'NO_MESSAGES_TO_REPORT',

    // Generic S3 / E9 templates; the caller supplies the {action} phrase
    ACTION_SUCCESSFUL: 'ACTION_SUCCESSFUL',
    ACTION_FAILED_RETRY: 'ACTION_FAILED_RETRY',
    SOMETHING_WENT_WRONG_RETRY: 'SOMETHING_WENT_WRONG_RETRY',

    // E38 — a live location ended while its pop-up was open
    LIVE_LOCATION_ENDED: 'LIVE_LOCATION_ENDED',

    // E28 / E35 / E36 / E37 / E55 — scheduled messages (FR193–FR196)
    MESSAGE_ALREADY_DELETED: 'MESSAGE_ALREADY_DELETED',
    // E27 — FR102 - Edit Text Message
    MESSAGE_EDIT_TIME_LIMIT: 'MESSAGE_EDIT_TIME_LIMIT',
    MESSAGE_ALREADY_SENT: 'MESSAGE_ALREADY_SENT',
    CANNOT_SEND_IN_CONVERSATION: 'CANNOT_SEND_IN_CONVERSATION',
    SCHEDULE_TIME_PAST: 'SCHEDULE_TIME_PAST',
    POLL_CLOSES_BEFORE_SCHEDULE: 'POLL_CLOSES_BEFORE_SCHEDULE',

    // FR97 — shown while a forward is being sent
    FORWARDING: 'FORWARDING',

    // Failures — shown only when the server sends no message of its own
    CHAT_UPDATE_FAILED: 'CHAT_UPDATE_FAILED',
    CHAT_PIN_FAILED: 'CHAT_PIN_FAILED',
    FAVOURITES_UPDATE_FAILED: 'FAVOURITES_UPDATE_FAILED',
    NOTIFICATIONS_UPDATE_FAILED: 'NOTIFICATIONS_UPDATE_FAILED',
    CHAT_CLEAR_FAILED: 'CHAT_CLEAR_FAILED',
    CHAT_DELETE_FAILED: 'CHAT_DELETE_FAILED',
    BLOCK_LIST_UPDATE_FAILED: 'BLOCK_LIST_UPDATE_FAILED',
    REPORT_SEND_FAILED: 'REPORT_SEND_FAILED',
    EXIT_GROUP_FAILED: 'EXIT_GROUP_FAILED',
    EXIT_GROUP_DELETE_FAILED: 'EXIT_GROUP_DELETE_FAILED',
    GROUP_UPDATE_FAILED: 'GROUP_UPDATE_FAILED',
};
